// §18.1 component inventory: "Toast + Undo — bottom-left; Mode-A recordings always toast
// with Undo (LG-5)." AM-4: eligibility is persistent "until the next user interaction" —
// NOT time-based, so this never auto-dismisses on a timer; the caller clears it when the
// next interaction happens (or the owner dismisses/undoes it directly).
import { X } from 'lucide-react';

export function Toast({
  message,
  actionLabel,
  onAction,
  onDismiss,
}: {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  onDismiss: () => void;
}): React.JSX.Element {
  return (
    <div
      role="status"
      className="fixed bottom-4 left-4 z-50 flex items-center gap-3 rounded-[var(--radius-card)] border border-border bg-surface px-4 py-3 text-sm text-ink shadow-lg"
    >
      <span>{message}</span>
      {actionLabel !== undefined && onAction !== undefined && (
        <button
          type="button"
          onClick={onAction}
          className="font-medium text-primary hover:underline"
        >
          {actionLabel}
        </button>
      )}
      <button
        type="button"
        aria-label="Dismiss"
        onClick={onDismiss}
        className="text-muted hover:text-ink"
      >
        <X size={14} />
      </button>
    </div>
  );
}
